module.exports = __webpack_public_path__ + "img/stock4.ec61f7da.png";